import React from 'react'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'

import StoreBanner from '../components/store-banner'
import PrimaryButton from '../components/primary-button'
import FeatureCard from '../components/feature-card'
import TestimonialsCard from '../components/testimonials-card'
import LanguageSwitcher from '../components/language-switcher'
import './home.css'

const Home = (props) => {
  const { t } = useTranslation();
  return (
    <div className="home-container10">
      <Helmet>
        <title>Spoil Blocker</title>
        <meta property="og:title" content="Spoil Blocker" />
      </Helmet>
      <div data-role="Header" className="home-header-container">
        <header className="home-header">
          <div className="home-logo1">
            <img alt="image" src="/logotype-dark.svg" className="home-image2" />
          </div>
          <div className="home-container11">
            <LanguageSwitcher />
            <StoreBanner></StoreBanner>
          </div>
        </header>
      </div>
      <div className="home-main">
        <div className="home-blur-background"></div>
        <div className="home-hero">
          <div className="home-container17">
            <h1 className="home-text16">
              <span className="Headline1">{t('hero.title')}</span>
              <br className="Headline1"></br>
              <span>{t('hero.subtitle')}</span>
              <br className="Headline1"></br>
            </h1>
            <PrimaryButton button={t('hero.getStarted')}></PrimaryButton>
          </div>
          <img alt="image" src="/iphonex-1200w.png" className="home-image3" />
        </div>
        <img
          alt="image"
          src="/turquoise-circle.svg"
          className="home-turquoise-cirble"
        />
        <img
          alt="image"
          src="/purple-circle.svg"
          className="home-purple-circle"
        />
        <img alt="image" src="/left.svg" className="home-left" />
        <img alt="image" src="/right.svg" className="home-right" />
      </div>
      <div className="home-features1">
        <h2 className="Headline2 home-text21">
          {t('features.headline')}
        </h2>
        <span className="home-text22">
          {t('features.subheadline')}
        </span>
        <div className="home-features2">
          <FeatureCard
            cardTitle={t('features.cards.manageUnwatched.title')}
            text={t('features.cards.manageUnwatched.description')}
          ></FeatureCard>
          <FeatureCard
            imageSrc="/02.svg"
            cardTitle={t('features.cards.spoilerFreeSchedule.title')}
            text={t('features.cards.spoilerFreeSchedule.description')}
          ></FeatureCard>
          <FeatureCard
            imageSrc="/03.svg"
            cardTitle={t('features.cards.spoilerFreeYoutube.title')}
            text={t('features.cards.spoilerFreeYoutube.description')}
          ></FeatureCard>
          <FeatureCard
            imageSrc="/04.svg"
            cardTitle={t('features.cards.nonSoccerVideos.title')}
            text={t('features.cards.nonSoccerVideos.description')}
          ></FeatureCard>
          <FeatureCard
            imageSrc="/05.svg"
            cardTitle={t('features.cards.spoilerFreeNews.title')}
            text={t('features.cards.spoilerFreeNews.description')}
          ></FeatureCard>
          <FeatureCard
            imageSrc="/06.svg"
            cardTitle={t('features.cards.blockApps.title')}
            text={t('features.cards.blockApps.description')}
          ></FeatureCard>
        </div>
      </div>
      {/* <div className="home-testimonials">
        <div className="home-container18">
          <div className="home-container19">
            <img alt="image" src="/quote-mark.svg" className="home-image4" />
            <h1 className="home-text23 Headline3">こんな経験ありませんか？</h1>
            <div className="home-container20">
              <TestimonialsCard imageSrc="/logo-4.svg"></TestimonialsCard>
            </div>
          </div>
          <div className="home-container21">
            <div className="home-container22">
              <TestimonialsCard
                src="/logo-1.svg"
                text="I used Landify and created a landing page for my startup within a week. The Landify UI Kit is simple and highly intuitive, so anyone can use it."
                text1="Jane Cooper"
                text2="CEO, Airbnb"
                imageSrc="/logo-1.svg"
              ></TestimonialsCard>
            </div>
            <div className="home-container23">
              <TestimonialsCard
                text="Landify saved our time in designing my company page."
                text1="Kristin Watson"
                text2="Co-Founder, FedEx"
                imageSrc="/logo-2.svg"
              ></TestimonialsCard>
            </div>
          </div>
        </div>
      </div> */}
      <div className="home-cta">
        <div className="home-container24">
          <div className="home-container25">
            <h2 className="Headline3 home-text24">
              {t('cta.headline')}
            </h2>
            <span className="home-text25">
              {t('cta.description')}
            </span>
            <span className="home-text26 Subtitle2">
              <span className="home-text27">{t('cta.getApp')}</span>
            </span>
            <StoreBanner></StoreBanner>
          </div>
          <div className="home-container26">
            <img
              alt="image"
              src="/iphonex-1200w.png"
              image_src="/iphonex-1200w.png"
              className="home-image5"
            />
            <img
              alt="image"
              src="/iphonex-1200w.png"
              image_src="/iphonex-1200w.png"
              className="home-image6"
            />
          </div>
        </div>
      </div>
      <div className="home-footer">
        <footer className="home-container27">
          <img alt="image" src="/logotype-light.svg" className="home-image3" />
          <div className="home-container29">
            <span className="home-text34 Body2">
              {t('footer.copyright')}
            </span>
          </div>
        </footer>
      </div>
    </div>
  )
}

export default Home
